import React from "react";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import { menusItem } from '../domain/menus';
import ModalMenu from '../components/ModalMenu';
import PcMenuList from '../components/PcMenuList';
import CheckIcon from '@material-ui/icons/Check';
import CloudIcon from '@material-ui/icons/Cloud';
import AddIcon from '@material-ui/icons/Add';


const menuLists = menusItem.map(menu => {
  let iconElement = <CheckIcon />;
  if (menu.icon === 'CheckIcon') iconElement = <CheckIcon />;
  if (menu.icon === 'CloudIcon') iconElement = <CloudIcon />;
  if (menu.icon === 'AddIcon') iconElement = <AddIcon />;

  return {
    anchor: menu.anchor,
    name: menu.name,
    isDisplayMenu: menu.isDisplayMenu,
    icon: iconElement,
  }
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menu: {
      display: 'none',
      // eslint-disable-next-line
      ['@media (min-width:980px)']: {
        display: 'block',
        top: '0.8%',
        position: 'fixed',
        right: '5%',
        color: 'white',
        fontWeight: 'bold',
      }
    },
    title: {
      fontSize: "3rem",
      background: "linear-gradient(-135deg, #E4A972, #9941D8)",
      "-webkit-background-clip": "text",
      color: "#9941D8",
      fontWeight: "bold",
      "-webkit-text-fill-color": "transparent",
      textAlign: 'center',
      margin: '10% 5% 5% 5%',
      // eslint-disable-next-line
      ['@media (min-width:780px)']: {
        fontSize: "4rem",
        textAlign: 'left',
        margin: '1% 1% 1% 5%',
      }
    },
    card: {
      background: 'white',
      width: "60%",
      position: 'relative',
      margin: '10% 20% 10% 20%',
      borderRadius: '50%',
      zIndex: 6,
      "-webkit-box-shadow": "0 10px 6px -6px #777",
      boxShadow: "0 10px 6px -6px #777",
      "-webkit-transition": "all 0.8s ease",
      transition: "all 0.8s ease",
      // eslint-disable-next-line
      ['@media (min-width:780px)']: {
        maxWidth: "345px",
        margin: '3% 35%',
        right: '0',
      }
    },
    cardArea: {
    },
    cardMedia: {
    },
    subTitle: {
      color: '#FFFFFF',
      fontSize: '2rem',
      fontWeight: "bold",
      textAlign: 'center',
      margin: '10% 5% 5% 5%',
      // eslint-disable-next-line
      ['@media (min-width:780px)']: {
        margin: '5% 5% 5% 5%',
        fontSize: '2.5rem',
      }
    }
  }),
);


const MySection: React.FC = () => {
  const classes = useStyles();

  return (
    <div className="section">
      <div className={classes.menu}>
        <PcMenuList
          menuLists={menuLists}
        />
      </div>
      <h2 className={classes.title}>
        Kou Portfolio
      </h2>
      <Card className={classes.card}>
        <CardActionArea className={classes.cardArea}>
          <CardMedia
            component="img"
            alt="Contemplative Reptile"
            image="https://cdn.awesome-linus.com/kou.png"
            title="Contemplative Reptile"
            className={classes.cardMedia}
          />
        </CardActionArea>
      </Card>
      <p className={classes.subTitle}>
        Backend Engineer
      </p>
      <ModalMenu />
    </div>
  );
}

export default MySection;
